const routes = [
  {
    path: '/user/alerts',
    component: () => import('@/views/user/Alerts/AlertsWrapper.vue'),
    children: [
      {
        path: '/user/alerts/',
        name: 'alertDetail',
        component: () => import('@/views/user/Alerts/Alert.vue'),
      },
    ],
  },
];

export default routes;
